var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.computedClass,style:(_vm.computedStyle)},[(_vm.showDefault)?_c('jazzicon',{staticClass:"user-picture default",attrs:{"address":_vm.address.hexEncode(),"diameter":_vm.diameter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }